import React from 'react';

import FormError from '../FormError';
import Option from './Option';
import Radio from './Radio';
import Pill from './Pill';

const RadioGroup = ({
  name,
  type = 'radio',
  variant = '',
  title,
  options = [],
  register,
  defaultChecked,
  checkbox,
  isPersonalBank = false,
  onChange,
  error,
}) => {
  function getType(type, option) {
    const { id, label, value, image, subtitle, details, component, unique, ...rest } = option;

    function isChecked() {
      if (checkbox) {
        return defaultChecked?.includes(id);
      } else {
        return defaultChecked === value;
      }
    }

    function noUniqueHandler() {
      const uniqueElements = document.querySelectorAll(`[name="${name}"][data-unique]`);
      uniqueElements.forEach(element => (element.checked = false));
    }

    function uniqueHandler() {
      const currentElement = document.querySelector(`#${id}`);
      const currentStatus = currentElement.checked;
      document.querySelectorAll(`[name="${name}"]`).forEach(el => (el.checked = false));
      currentElement.checked = currentStatus;
    }

    let optionType;

    switch (type) {
      case 'card':
        optionType = (
          <Option
            key={id}
            id={id}
            name={name}
            variant={variant}
            title={label}
            subtitle={subtitle}
            isPersonalBank={isPersonalBank}
            image={image}
            details={details}
            register={register}
            error={error}
            defaultChecked={defaultChecked === id}
            value={value}
            component={component}
            checkbox={checkbox}
            onChange={e => {
              onChange && onChange(e);
            }}
            {...rest}
          />
        );
        break;
      case 'radio':
        optionType = (
          <Radio
            key={id}
            id={id}
            name={name}
            label={label}
            register={register}
            error={error}
            defaultChecked={defaultChecked === id}
            value={value}
            checkbox={checkbox}
            onChange={e => {
              onChange && onChange(e);
            }}
          />
        );
        break;
      case 'pill':
        optionType = (
          <Pill
            key={id}
            id={id}
            name={name}
            label={label}
            register={register}
            error={error}
            defaultChecked={isChecked()}
            value={value}
            checkbox={checkbox}
            onChange={e => {
              !unique && noUniqueHandler();
              unique && uniqueHandler();
              onChange && onChange(e);
            }}
            unique={unique}
          />
        );
        break;

      default:
        optionType = null;
        break;
    }

    return optionType;
  }

  return (
    <div className="radio-group">
      {title && <span>{title}</span>}

      {options.length && type === 'pill' && (
        <div className="owl">{options.map(option => getType(type, option))}</div>
      )}

      {options.length && type !== 'pill' && options.map(option => getType(type, option))}

      {error && <FormError>{error.message}</FormError>}

      <style jsx>{`
        .radio-group {
          margin-bottom: 32px;
        }

        span {
          display: block;
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 16px;
        }
      `}</style>

      <style jsx>{`
        .owl :global(> *) {
          margin-right: ${type === 'pill' ? '8px' : 0};
        }
      `}</style>
    </div>
  );
};

export default RadioGroup;
